"use strict";

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var common_1 = require("../../common");

var Graphics = require("../../graphics");

var Specification = require("../../specification");

var chart_element_1 = require("../chart_element");

var object_1 = require("../object");

function facetRows(table, indices, columns) {
  if (columns == null) {
    return [indices];
  } else {
    var facets = new common_1.MultistringHashMap();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      var _loop = function _loop() {
        var g = _step.value;
        var row = table.getGroupedContext(g);
        var facetValues = columns.map(function (c) {
          return c.getStringValue(row);
        });

        if (facets.has(facetValues)) {
          facets.get(facetValues).push(g);
        } else {
          facets.set(facetValues, [g]);
        }
      };

      for (var _iterator = indices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return Array.from(facets.values());
  }
}

exports.facetRows = facetRows;

var LinksClass =
/*#__PURE__*/
function (_chart_element_1$Char) {
  _inherits(LinksClass, _chart_element_1$Char);

  function LinksClass() {
    var _this;

    _classCallCheck(this, LinksClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LinksClass).apply(this, arguments));
    _this.attributeNames = ["color", "opacity"];
    _this.attributes = {
      color: {
        name: "color",
        type: Specification.AttributeType.Color,
        solverExclude: true,
        defaultValue: null,
        stateExclude: true
      },
      strokeWidth: {
        name: "strokeWidth",
        type: Specification.AttributeType.Number,
        solverExclude: true,
        defaultValue: null,
        stateExclude: true
      },
      opacity: {
        name: "opacity",
        type: Specification.AttributeType.Number,
        solverExclude: true,
        defaultValue: 1,
        defaultRange: [0, 1],
        stateExclude: true
      }
    };
    return _this;
  }

  _createClass(LinksClass, [{
    key: "resolveLinkAnchorPoints",
    value: function resolveLinkAnchorPoints(anchorPoints, glyph) {
      return anchorPoints.map(function (anchorPoint) {
        var pt = {
          anchorIndex: common_1.indexOf(glyph.marks, function (x) {
            return x.classID == "mark.anchor";
          }),
          x: {
            element: common_1.indexOf(glyph.marks, function (e) {
              return e._id == anchorPoint.x.element;
            }),
            attribute: anchorPoint.x.attribute
          },
          y: {
            element: common_1.indexOf(glyph.marks, function (e) {
              return e._id == anchorPoint.y.element;
            }),
            attribute: anchorPoint.y.attribute
          },
          direction: anchorPoint.direction
        };
        return pt;
      });
    }
  }, {
    key: "getAnchorPoints",
    value: function getAnchorPoints(renderState, anchorPoints, plotSegmentClass, glyphState, row) {
      var dx = glyphState.attributes.x;
      var dy = glyphState.attributes.y;
      var anchorIndex = anchorPoints[0].anchorIndex;
      dx -= glyphState.marks[anchorIndex].attributes.x;
      dy -= glyphState.marks[anchorIndex].attributes.y;
      var cs = plotSegmentClass.getCoordinateSystem();
      return {
        points: anchorPoints.map(function (pt) {
          var x = pt.x.element < 0 ? glyphState.attributes[pt.x.attribute] : glyphState.marks[pt.x.element].attributes[pt.x.attribute];
          var y = pt.y.element < 0 ? glyphState.attributes[pt.y.attribute] : glyphState.marks[pt.y.element].attributes[pt.y.attribute];
          var px = dx + x;
          var py = dy + y;
          return {
            x: px,
            y: py,
            direction: pt.direction
          };
        }),
        curveness: this.object.properties.curveness != null ? this.object.properties.curveness : 30,
        coordinateSystem: cs,
        color: renderState.colorFunction(row),
        opacity: renderState.opacityFunction(row),
        strokeWidth: renderState.strokeWidthFunction(row),
        "data-datum": row.indices.map(function (i) {
          return Object.assign({
            _x: cs.getBaseTransform().x + glyphState.attributes.x,
            _y: cs.getBaseTransform().y + glyphState.attributes.y
          }, row.table.rows[i]);
        })
      };
    }
  }, {
    key: "renderLinks",
    value: function renderLinks(linkGraphics, lineType, anchorGroups) {
      var _this2 = this;

      switch (linkGraphics) {
        case "line":
          {
            return Graphics.makeGroup(anchorGroups.map(function (anchors) {
              var lines = [];

              for (var i = 0; i < anchors.length - 1; i++) {
                var path = Graphics.makePath({
                  strokeColor: anchors[i][0].color,
                  strokeOpacity: anchors[i][0].opacity,
                  strokeWidth: anchors[i][0].strokeWidth
                });
                LinksClass.LinkPath(path, linkGraphics, lineType, anchors[i][0], anchors[i + 1][1]);
                path.path["data-datum"] = JSON.stringify(anchors[i][0]["data-datum"].concat(anchors[i + 1][1]["data-datum"]).map(function (props) {
                  return Object.assign({
                    _TYPE: "link",
                    _MARKID: _this2.object.properties.name
                  }, props);
                }));
                lines.push(path.path);
              }

              return Graphics.makeGroup(lines);
            }));
          }

        case "band":
          {
            var splitAnchors = true;

            if (splitAnchors) {
              var map = new Map();

              var hashAnchor = function hashAnchor(points) {
                var dx = points[0].x - points[1].x;
                var dy = points[0].y - points[1].y;
                var dirX = points[0].direction.x;
                var dirY = points[0].direction.y;
                return [points[0].x, points[0].y, points[1].x, points[1].y, Math.sign(dx * dirY - dy * dirX)].join(",");
              };

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = anchorGroups[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var anchors = _step2.value;

                  for (var i = 0; i < anchors.length - 1; i++) {
                    var a1 = anchors[i][0];
                    var a2 = anchors[i + 1][1];
                    var hash1 = hashAnchor(a1.points);
                    var hash2 = hashAnchor(a2.points);

                    if (map.has(hash1)) {
                      map.get(hash1).push([a1, a2]);
                    } else {
                      map.set(hash1, [[a1, a2]]);
                    }

                    if (map.has(hash2)) {
                      map.get(hash2).push([a2, a1]);
                    } else {
                      map.set(hash2, [[a2, a1]]);
                    }
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              map.forEach(function (anchors, points) {
                var x1 = anchors[0][0].points[0].x;
                var y1 = anchors[0][0].points[0].y;
                var x2 = anchors[0][0].points[1].x;
                var y2 = anchors[0][0].points[1].y;
                var p1 = anchors[0][0].coordinateSystem.transformPoint(x1, y1);
                var p2 = anchors[0][0].coordinateSystem.transformPoint(x2, y2);
                var pd = Math.sqrt((p2.x - p1.x) * (p2.x - p1.x) + (p2.y - p1.y) * (p2.y - p1.y));
                var cx = (p1.x + p2.x) / 2;
                var cy = (p1.y + p2.y) / 2;
                var order = anchors.map(function (anchor) {
                  var p = anchor[1].coordinateSystem.transformPoint(anchor[1].points[0].x, anchor[1].points[0].y);
                  var proj = (p.x - cx) * (p2.x - p1.x) + (p.y - cy) * (p2.y - p1.y);
                  var distance = Math.sqrt((p.x - cx) * (p.x - cx) + (p.y - cy) * (p.y - cy));
                  var cosTheta = proj / distance / pd;

                  if (cosTheta > 0.999999) {
                    return 1 + distance;
                  } else if (cosTheta < -0.999999) {
                    return -1 - distance;
                  }

                  return cosTheta; // return proj;
                });
                var indices = [];
                var totalWidth = 0;

                for (var i = 0; i < anchors.length; i++) {
                  indices.push(i);
                  totalWidth += anchors[i][0].strokeWidth;
                }

                indices.sort(function (a, b) {
                  return order[a] - order[b];
                });
                var cWidth = 0;

                for (var _i = 0; _i < anchors.length; _i++) {
                  var m = indices[_i];
                  var k1 = cWidth / totalWidth;
                  cWidth += anchors[m][0].strokeWidth;
                  var k2 = cWidth / totalWidth;
                  anchors[m][0].points[0].x = x1 + (x2 - x1) * k1;
                  anchors[m][0].points[0].y = y1 + (y2 - y1) * k1;
                  anchors[m][0].points[1].x = x1 + (x2 - x1) * k2;
                  anchors[m][0].points[1].y = y1 + (y2 - y1) * k2;
                }
              });
            }

            return Graphics.makeGroup(anchorGroups.map(function (anchors) {
              var bands = [];

              for (var _i2 = 0; _i2 < anchors.length - 1; _i2++) {
                var path = Graphics.makePath({
                  fillColor: anchors[_i2][0].color,
                  fillOpacity: anchors[_i2][0].opacity
                });
                LinksClass.LinkPath(path, linkGraphics, lineType, anchors[_i2][0], anchors[_i2 + 1][1]);
                path.path["data-datum"] = JSON.stringify(anchors[_i2][0]["data-datum"].concat(anchors[_i2 + 1][1]["data-datum"]).map(function (props) {
                  return Object.assign({
                    _TYPE: "link",
                    _MARKID: _this2.object.properties.name
                  }, props);
                }));
                bands.push(path.path);
              }

              return Graphics.makeGroup(bands);
            }));
          }
      }
    }
    /** Get the graphics that represent this layout */

  }, {
    key: "getGraphics",
    value: function getGraphics(manager) {
      return null;
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      var props = this.object.properties;
      var widgets = [manager.sectionHeader("Line Type"), manager.row("Type", manager.inputSelect({
        property: "interpolationType"
      }, {
        type: "dropdown",
        showLabel: true,
        options: ["line", "bezier", "circle"],
        labels: ["Line", "Bezier", "Arc"]
      }))];

      if (props.interpolationType == "bezier") {
        widgets.push(manager.row("Curveness", manager.inputNumber({
          property: "curveness"
        }, {
          showSlider: true,
          minimum: 0,
          sliderRange: [0, 500]
        })));
      }

      widgets.push(manager.sectionHeader("Style"));
      widgets.push(manager.mappingEditor("Color", "color", {})); // if (props.linkType == "line") {

      widgets.push(manager.mappingEditor("Width", "strokeWidth", {
        hints: {
          rangeNumber: [0, 5]
        },
        defaultValue: 1,
        numberOptions: {
          showSlider: true,
          sliderRange: [0, 5],
          minimum: 0
        }
      })); // }

      widgets.push(manager.mappingEditor("Opacity", "opacity", {
        hints: {
          rangeNumber: [0, 1]
        },
        defaultValue: 1,
        numberOptions: {
          showSlider: true,
          minimum: 0,
          maximum: 1
        }
      }));
      return widgets;
    }
  }], [{
    key: "BandPath",
    value: function BandPath(path, anchor) {
      var reversed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var newPath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var p0, p1;

      if (reversed) {
        p1 = anchor.points[0];
        p0 = anchor.points[1];
      } else {
        p0 = anchor.points[0];
        p1 = anchor.points[1];
      }

      if (newPath) {
        var p = Graphics.transform(anchor.coordinateSystem.getBaseTransform(), anchor.coordinateSystem.transformPoint(p0.x, p0.y));
        path.moveTo(p.x, p.y);
      }

      if (anchor.coordinateSystem instanceof Graphics.PolarCoordinates) {
        // let p = Graphics.transform(anchor.coordinateSystem.getBaseTransform(), anchor.coordinateSystem.transformPoint(p1.x, p1.y));
        path.polarLineTo(anchor.coordinateSystem.origin.x, anchor.coordinateSystem.origin.y, 90 - p0.x, p0.y, 90 - p1.x, p1.y);
      } else {
        var _p = Graphics.transform(anchor.coordinateSystem.getBaseTransform(), anchor.coordinateSystem.transformPoint(p1.x, p1.y));

        path.lineTo(_p.x, _p.y);
      }
    }
  }, {
    key: "ConnectionPath",
    value: function ConnectionPath(path, interpType, p1, d1, curveness1, p2, d2, curveness2) {
      var newPath = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;

      if (newPath) {
        path.moveTo(p1.x, p1.y);
      }

      switch (interpType) {
        case "line":
          {
            path.lineTo(p2.x, p2.y);
          }
          break;

        case "bezier":
          {
            var dScaler1 = curveness1;
            var dScaler2 = curveness2;
            path.cubicBezierCurveTo(p1.x + d1.x * dScaler1, p1.y + d1.y * dScaler1, p2.x + d2.x * dScaler2, p2.y + d2.y * dScaler2, p2.x, p2.y);
          }
          break;

        case "circle":
          {
            var cx = (p1.x + p2.x) / 2,
                cy = (p1.y + p2.y) / 2;
            var dx = p1.y - p2.y,
                dy = p2.x - p1.x; // it doesn't matter if we normalize d or not

            if (Math.abs(d1.x * dx + d1.y * dy) < 1e-6) {
              // Degenerate case, just a line from p1 to p2
              path.lineTo(p2.x, p2.y);
            } else {
              // Origin = c + d t
              // Solve for t: d1 dot (c + t d - p) = 0
              var t = (d1.x * (cx - p1.x) + d1.y * (cy - p1.y)) / (d1.x * dx + d1.y * dy);
              var o = {
                x: cx - dx * t,
                y: cy - dy * t
              }; // the center of the circle

              var r = common_1.Geometry.pointDistance(o, p1);
              var scaler = 180 / Math.PI;
              var angle1 = Math.atan2(p1.y - o.y, p1.x - o.x) * scaler;
              var angle2 = Math.atan2(p2.y - o.y, p2.x - o.x) * scaler;
              var sign = (p1.y - o.y) * d1.x - (p1.x - o.x) * d1.y;

              if (sign > 0) {
                while (angle2 > angle1) {
                  angle2 -= 360;
                }
              }

              if (sign < 0) {
                while (angle2 < angle1) {
                  angle2 += 360;
                }
              }

              path.polarLineTo(o.x, o.y, angle1, r, angle2, r, false);
            }
          }
      }
    }
  }, {
    key: "LinkPath",
    value: function LinkPath(path, linkType, interpType, anchor1, anchor2) {
      switch (linkType) {
        case "line":
          {
            var a1p0 = anchor1.coordinateSystem.transformPointWithBase(anchor1.points[0].x, anchor1.points[0].y);
            var a2p0 = anchor2.coordinateSystem.transformPointWithBase(anchor2.points[0].x, anchor2.points[0].y);
            var a1d0 = anchor1.coordinateSystem.transformDirectionAtPointWithBase(anchor1.points[0].x, anchor1.points[0].y, anchor1.points[0].direction.x, anchor1.points[0].direction.y);
            var a2d0 = anchor2.coordinateSystem.transformDirectionAtPointWithBase(anchor2.points[0].x, anchor2.points[0].y, anchor2.points[0].direction.x, anchor2.points[0].direction.y);
            LinksClass.ConnectionPath(path, interpType, a1p0, a1d0, anchor1.curveness, a2p0, a2d0, anchor2.curveness, true);
          }
          break;

        case "band":
          {
            // Determine if we should reverse the band
            var _a1p = anchor1.coordinateSystem.transformPointWithBase(anchor1.points[0].x, anchor1.points[0].y);

            var a1p1 = anchor1.coordinateSystem.transformPointWithBase(anchor1.points[1].x, anchor1.points[1].y);

            var _a2p = anchor2.coordinateSystem.transformPointWithBase(anchor2.points[0].x, anchor2.points[0].y);

            var a2p1 = anchor2.coordinateSystem.transformPointWithBase(anchor2.points[1].x, anchor2.points[1].y);

            var _a1d = anchor1.coordinateSystem.transformDirectionAtPointWithBase(anchor1.points[0].x, anchor1.points[0].y, anchor1.points[0].direction.x, anchor1.points[0].direction.y);

            var a1d1 = anchor1.coordinateSystem.transformDirectionAtPointWithBase(anchor1.points[1].x, anchor1.points[1].y, anchor1.points[1].direction.x, anchor1.points[1].direction.y);

            var _a2d = anchor2.coordinateSystem.transformDirectionAtPointWithBase(anchor2.points[0].x, anchor2.points[0].y, anchor2.points[0].direction.x, anchor2.points[0].direction.y);

            var a2d1 = anchor2.coordinateSystem.transformDirectionAtPointWithBase(anchor2.points[1].x, anchor2.points[1].y, anchor2.points[1].direction.x, anchor2.points[1].direction.y);
            var cross1 = common_1.Geometry.vectorCross(_a1d, {
              x: a1p1.x - _a1p.x,
              y: a1p1.y - _a1p.y
            });
            var cross2 = common_1.Geometry.vectorCross(_a2d, {
              x: a2p1.x - _a2p.x,
              y: a2p1.y - _a2p.y
            });
            var reverseBand = cross1 * cross2 > 0;

            if (reverseBand) {
              // anchor1[0] -> anchor1[1]
              LinksClass.BandPath(path, anchor1, false, true); // anchor1[1] -> anchor2[0]

              LinksClass.ConnectionPath(path, interpType, a1p1, a1d1, anchor1.curveness, _a2p, _a2d, anchor2.curveness, false); // anchor2[0] -> anchor2[1]

              LinksClass.BandPath(path, anchor2, false, false); // anchor2[1] -> anchor1[0]

              LinksClass.ConnectionPath(path, interpType, a2p1, a2d1, anchor2.curveness, _a1p, _a1d, anchor1.curveness, false);
              path.closePath();
            } else {
              // anchor1[0] -> anchor1[1]
              LinksClass.BandPath(path, anchor1, false, true); // anchor1[1] -> anchor2[1]

              LinksClass.ConnectionPath(path, interpType, a1p1, a1d1, anchor1.curveness, a2p1, a2d1, anchor2.curveness, false); // anchor2[1] -> anchor2[0]

              LinksClass.BandPath(path, anchor2, true, false); // anchor2[0] -> anchor1[0]

              LinksClass.ConnectionPath(path, interpType, _a2p, _a2d, anchor2.curveness, _a1p, _a1d, anchor1.curveness, false);
              path.closePath();
            }
          }
          break;
      }
    }
  }]);

  return LinksClass;
}(chart_element_1.ChartElementClass);

LinksClass.metadata = {
  iconPath: "link/tool"
};
exports.LinksClass = LinksClass;

var SeriesLinksClass =
/*#__PURE__*/
function (_LinksClass) {
  _inherits(SeriesLinksClass, _LinksClass);

  function SeriesLinksClass() {
    _classCallCheck(this, SeriesLinksClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(SeriesLinksClass).apply(this, arguments));
  }

  _createClass(SeriesLinksClass, [{
    key: "getGraphics",

    /** Get the graphics that represent this layout */
    value: function getGraphics(manager) {
      var _this3 = this;

      var props = this.object.properties;
      var linkGroup = Graphics.makeGroup([]);
      var renderState = {
        colorFunction: this.parent.resolveMapping(this.object.mappings.color, {
          r: 0,
          g: 0,
          b: 0
        }),
        opacityFunction: this.parent.resolveMapping(this.object.mappings.opacity, 1),
        strokeWidthFunction: this.parent.resolveMapping(this.object.mappings.strokeWidth, 1)
      };
      var links = this.object;
      var chart = this.parent.object;
      var chartState = this.parent.state; // Resolve the anchors

      var layoutIndex = common_1.indexOf(chart.elements, function (l) {
        return l._id == props.linkThrough.plotSegment;
      });
      var layout = chart.elements[layoutIndex];
      var mark = common_1.getById(chart.glyphs, layout.glyph);
      var layoutState = chartState.elements[layoutIndex];
      var layoutClass = manager.getPlotSegmentClass(layoutState);
      var table = this.parent.dataflow.getTable(layout.table);
      var facets = facetRows(table, layoutState.dataRowIndices, props.linkThrough.facetExpressions.map(function (x) {
        return _this3.parent.dataflow.cache.parse(x);
      }));
      var rowToMarkState = new Map();

      for (var i = 0; i < layoutState.dataRowIndices.length; i++) {
        rowToMarkState.set(layoutState.dataRowIndices[i].join(","), layoutState.glyphs[i]);
      }

      var anchor1 = this.resolveLinkAnchorPoints(props.anchor1, mark);
      var anchor2 = this.resolveLinkAnchorPoints(props.anchor2, mark);
      var anchors = facets.map(function (facet) {
        return facet.map(function (index) {
          var markState = rowToMarkState.get(index.join(","));
          var row = table.getGroupedContext(index);

          if (markState) {
            return [_this3.getAnchorPoints(renderState, anchor1, layoutClass, markState, row), _this3.getAnchorPoints(renderState, anchor2, layoutClass, markState, row)];
          } else {
            return null;
          }
        });
      });
      linkGroup.elements.push(this.renderLinks(props.linkType, props.interpolationType, anchors));
      return linkGroup;
    }
  }]);

  return SeriesLinksClass;
}(LinksClass);

SeriesLinksClass.classID = "links.through";
SeriesLinksClass.type = "links";
SeriesLinksClass.defaultProperties = {
  visible: true
};
exports.SeriesLinksClass = SeriesLinksClass;

var LayoutsLinksClass =
/*#__PURE__*/
function (_LinksClass2) {
  _inherits(LayoutsLinksClass, _LinksClass2);

  function LayoutsLinksClass() {
    _classCallCheck(this, LayoutsLinksClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(LayoutsLinksClass).apply(this, arguments));
  }

  _createClass(LayoutsLinksClass, [{
    key: "getGraphics",

    /** Get the graphics that represent this layout */
    value: function getGraphics(manager) {
      var props = this.object.properties;
      var linkGroup = Graphics.makeGroup([]);
      var renderState = {
        colorFunction: this.parent.resolveMapping(this.object.mappings.color, {
          r: 0,
          g: 0,
          b: 0
        }),
        opacityFunction: this.parent.resolveMapping(this.object.mappings.opacity, 1),
        strokeWidthFunction: this.parent.resolveMapping(this.object.mappings.strokeWidth, 1)
      };
      var links = this.object;
      var chart = this.parent.object;
      var chartState = this.parent.state;
      var dataset = this.parent.dataflow;
      var layoutIndices = props.linkBetween.plotSegments.map(function (lid) {
        return common_1.indexOf(chart.elements, function (l) {
          return l._id == lid;
        });
      });
      var layouts = layoutIndices.map(function (i) {
        return chart.elements[i];
      });
      var layoutStates = layoutIndices.map(function (i) {
        return chartState.elements[i];
      });
      var layoutClasses = layoutStates.map(function (layoutState) {
        return manager.getPlotSegmentClass(layoutState);
      });
      var glyphs = layouts.map(function (layout) {
        return common_1.getById(chart.glyphs, layout.glyph);
      });
      var anchor1 = this.resolveLinkAnchorPoints(props.anchor1, glyphs[0]);
      var anchor2 = this.resolveLinkAnchorPoints(props.anchor2, glyphs[1]);

      for (var shift = 0; shift < layoutStates.length - 1; shift++) {
        var rowIndicesMap = new Map();

        for (var i = 0; i < layoutStates[shift].dataRowIndices.length; i++) {
          rowIndicesMap.set(layoutStates[shift].dataRowIndices[i].join(","), i);
        }

        var table = this.parent.dataflow.getTable(layouts[0].table);
        var anchors = [];

        for (var i1 = 0; i1 < layoutStates[shift + 1].dataRowIndices.length; i1++) {
          var rowIndex = layoutStates[shift + 1].dataRowIndices[i1];
          var rowIndexJoined = rowIndex.join(",");

          if (rowIndicesMap.has(rowIndexJoined)) {
            var i0 = rowIndicesMap.get(rowIndexJoined);
            var row = table.getGroupedContext(rowIndex);
            anchors.push([[this.getAnchorPoints(renderState, anchor1, layoutClasses[shift], layoutStates[shift].glyphs[i0], row), null], [null, this.getAnchorPoints(renderState, anchor2, layoutClasses[shift + 1], layoutStates[shift + 1].glyphs[i1], row)]]);
          }
        }

        linkGroup.elements.push(this.renderLinks(props.linkType, props.interpolationType, anchors));
      }

      return linkGroup;
    }
  }]);

  return LayoutsLinksClass;
}(LinksClass);

LayoutsLinksClass.classID = "links.between";
LayoutsLinksClass.type = "links";
LayoutsLinksClass.defaultProperties = {
  visible: true
};
exports.LayoutsLinksClass = LayoutsLinksClass;

var TableLinksClass =
/*#__PURE__*/
function (_LinksClass3) {
  _inherits(TableLinksClass, _LinksClass3);

  function TableLinksClass() {
    _classCallCheck(this, TableLinksClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(TableLinksClass).apply(this, arguments));
  }

  _createClass(TableLinksClass, [{
    key: "getGraphics",

    /** Get the graphics that represent this layout */
    value: function getGraphics(manager) {
      var _this4 = this;

      var props = this.object.properties;
      var linkGroup = Graphics.makeGroup([]);
      var renderState = {
        colorFunction: this.parent.resolveMapping(this.object.mappings.color, {
          r: 0,
          g: 0,
          b: 0
        }),
        opacityFunction: this.parent.resolveMapping(this.object.mappings.opacity, 1),
        strokeWidthFunction: this.parent.resolveMapping(this.object.mappings.strokeWidth, 1)
      };
      var links = this.object;
      var chart = this.parent.object;
      var chartState = this.parent.state;
      var dataset = this.parent.dataflow;
      var layoutIndices = props.linkTable.plotSegments.map(function (lid) {
        return common_1.indexOf(chart.elements, function (l) {
          return l._id == lid;
        });
      });
      var layouts = layoutIndices.map(function (i) {
        return chart.elements[i];
      });
      var layoutStates = layoutIndices.map(function (i) {
        return chartState.elements[i];
      });
      var layoutClasses = layoutStates.map(function (layoutState) {
        return manager.getPlotSegmentClass(layoutState);
      });
      var glyphs = layouts.map(function (layout) {
        return common_1.getById(chart.glyphs, layout.glyph);
      });
      var anchor1 = this.resolveLinkAnchorPoints(props.anchor1, glyphs[0]);
      var anchor2 = this.resolveLinkAnchorPoints(props.anchor2, glyphs[1]);
      var linkTable = this.parent.dataflow.getTable(props.linkTable.table);
      var tables = layouts.map(function (layout, layoutIndex) {
        var table = _this4.parent.dataflow.getTable(layout.table);

        var id2RowGlyphIndex = new Map();

        for (var i = 0; i < layoutStates[layoutIndex].dataRowIndices.length; i++) {
          var rowIndex = layoutStates[layoutIndex].dataRowIndices[i];
          var rowIDs = rowIndex.map(function (i) {
            return table.getRow(i).id;
          }).join(",");
          id2RowGlyphIndex.set(rowIDs, [rowIndex, i]);
        }

        return {
          table: table,
          id2RowGlyphIndex: id2RowGlyphIndex
        };
      }); // Prepare data rows

      var rowIndices = [];

      for (var i = 0; i < linkTable.rows.length; i++) {
        rowIndices.push(i);
      }

      var anchors = [];

      for (var _i3 = 0; _i3 < rowIndices.length; _i3++) {
        var rowIndex = rowIndices[_i3];
        var row = linkTable.getGroupedContext([rowIndex]);
        var rowItem = linkTable.getRow(rowIndex);
        var r1 = tables[0].id2RowGlyphIndex.get(rowItem.source_id.toString());
        var r2 = tables[1].id2RowGlyphIndex.get(rowItem.target_id.toString());

        if (!r1 || !r2) {
          continue;
        }

        var _r = _slicedToArray(r1, 2),
            iRow0 = _r[0],
            i0 = _r[1];

        var _r2 = _slicedToArray(r2, 2),
            iRow1 = _r2[0],
            i1 = _r2[1];

        anchors.push([[this.getAnchorPoints(renderState, anchor1, layoutClasses[0], layoutStates[0].glyphs[i0], row), null], [null, this.getAnchorPoints(renderState, anchor2, layoutClasses[1], layoutStates[1].glyphs[i1], row)]]);
      }

      linkGroup.elements.push(this.renderLinks(props.linkType, props.interpolationType, anchors));
      return linkGroup;
    }
  }]);

  return TableLinksClass;
}(LinksClass);

TableLinksClass.classID = "links.table";
TableLinksClass.type = "links";
TableLinksClass.defaultProperties = {
  visible: true
};
exports.TableLinksClass = TableLinksClass;

function registerClasses() {
  object_1.ObjectClasses.Register(SeriesLinksClass);
  object_1.ObjectClasses.Register(LayoutsLinksClass);
  object_1.ObjectClasses.Register(TableLinksClass);
}

exports.registerClasses = registerClasses;